import { Input, Output, EventEmitter, Directive } from '@angular/core';
import { DocumentEndorsementLocation } from './document-endorsement-location.model';
import { EndorsementImage, SystemEndorsementImage, UniqueEndorsementImage } from './endorsement-image';
import { OutgoingEraseSignedEndorsement, OutgoingSignEndorsement } from './endorsement-process.model';

@Directive()
export class EndorsementBase {
  @Input() endorsementLocation: DocumentEndorsementLocation;
  @Input() endorsementImage: EndorsementImage | UniqueEndorsementImage | SystemEndorsementImage;
  @Input() hideIfSigned: boolean;
  @Input() disableFocus: boolean;
  @Input() isEndorsementDisabled: boolean;
  @Input() areAllEndorsementsSigned: boolean;

  @Output() signEndorsement: EventEmitter<
    OutgoingSignEndorsement
  > = new EventEmitter();
  @Output() eraseSignedEndorsement: EventEmitter<
    OutgoingEraseSignedEndorsement
  > = new EventEmitter();
}
